export default "/assets/images/unit-slide2.jpg?4bd9b9fb4e2a0f099713e91c6c9783e5";